import { canGetOrganizationHierarchyPage } from "@/route-authorization";
export const gdpr = {
  routes: [
    {
      path: "/department",
      component: () => import("../organization-department-view"),
    },
  ],
};

export const workspace = {
  routes: [
    {
      path: "/workspace/library/department",
      component: () => import("../workspace-library-department-view"),
    },
  ],
};

export const management = {
  routes: [
  ],
};

// Organizasyon şeması: `department.parent` ağacı (K3), flowy kutu grafiği olarak çizilir (eski `unit` grafiğinin görünümü).
export const organization = {
  routes: [
    {
      path: "/organization/hierarchy",
      meta: { rules: [canGetOrganizationHierarchyPage] }, // TKP-150
      component: () => import("../organization-department-graph-view"),
    },
    {
      // Birim süreç şeması — şemadaki birim kutusunun büyüteç simgesinden açılır.
      // Rota `department-process` modülünde DEĞİL: oradaki router/index.js TKP-124 ile kaldırıldı ve bekçi dosyanın
      // geri gelmemesini bekliyor (tests/unit/guard/retired-entity-screens.spec.js).
      path: "/organization/department/:department/processes",
      meta: { rules: [canGetOrganizationHierarchyPage] }, // TKP-150
      component: () => import("../../department-process/organization-department-process-graph-view"),
    },
    {
      path: "/organization/unit-hierarchy",
      redirect: "/organization/hierarchy",
    },
  ],
};
